export default ({ request }) => ({
  // 获取产量记录列表
  get_production_records(params) {
    return request({
      url: '/platform/v1/production_records/list',
      method: 'get',
      params: params
    })
  },
  
  // 添加产量记录
  post_production_record(data) {
    return request({
      url: '/platform/v1/production_records/add',
      method: 'post',
      data: data
    })
  },
  
  // 更新产量记录
  updateProductionRecord(id, data) {
    return request({
      url: `/platform/v1/production_records/update`,
      method: 'post',
      data: {
        ...data,
        id: id
      }
    })
  },
  
  // 删除产量记录
  deleteProductionRecord(id) {
    return request({
      url: '/platform/v1/production_records/delete',
      method: 'post',
      data: { id: id }
    })
  },
  
  // 获取产量图表数据
  getProductionChartData(params) {
    return request({
      url: '/platform/v1/production_records/list',
      method: 'get',
      params: {
        ...params,
        page_size: 100 // 获取足够多的数据用于图表
      }
    })
  },

  // 异步批量添加农场生产记录
  batchAddFarmProductionAsync(data) {
    return request({
      url: '/platform/v1/production_records/batch-add-farm-production-async',
      method: 'post',
      data: data
    })
  },

  // 获取任务状态
  getTaskStatus(taskId) {
    return request({
      url: `/platform/v1/production_records/task-status/${taskId}`,
      method: 'get'
    })
  },

  // 获取年度生产热图数据
  getAnnualHeatmap(params) {
    return request({
      url: '/platform/v1/production_records/annual-heatmap',
      method: 'get',
      params: params  // { year, farm_id, item_id, record_type }
    })
  },

  // 获取产奶个体数量曲线
  getIndividualCountCurve(params) {
    return request({
      url: '/platform/v1/production_records/individual-count-curve',
      method: 'get',
      params: params  // { start_date, end_date, farm_id, item_id, group_by }
    })
  },

  // 获取产奶量曲线（区分实际和估算记录）
  getProductionAmountCurve(params) {
    return request({
      url: '/platform/v1/production_records/production-amount-curve',
      method: 'get',
      params: params  // { start_date, end_date, farm_id, item_id, group_by, record_type }
    })
  },

  // 获取产奶时长排名
  getProducingDurationRanking(params) {
    return request({
      url: '/platform/v1/production_records/producing-duration-ranking',
      method: 'get',
      params: params  // { farm_id, limit }
    })
  },

  // 获取个体近一个月统计数据
  getIndividualMonthlyStats(item_id) {
    return request({
      url: '/platform/v1/production_records/individual-monthly-stats',
      method: 'get',
      params: { item_id }
    })
  }
})